<template>
  <div
    class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
    @click.self="$emit('cancel')"
  >
    <div class="bg-white rounded-xl shadow-xl max-w-md w-full p-6 max-h-full overflow-y-auto">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">
        {{ limited ? 'Sign out' : 'Account' }}
      </h2>

      <!-- No PIN configured: sign-out only -->
      <p v-if="limited" class="text-base text-gray-600 leading-6 mb-6">
        This kiosk has no admin PIN. Set one at
        <span class="font-medium text-gray-900">wrestlingiq.com/kiosk_tokens</span>
        to add or switch accounts.
      </p>

      <!-- Saved accounts -->
      <div v-else class="flex flex-col gap-2 mb-6">
        <button
          v-for="kiosk in kiosks"
          :key="kiosk.id"
          class="flex items-center gap-3 w-full p-3 rounded-lg border text-left transition hover:bg-gray-50"
          :class="isActive(kiosk) ? 'border-2' : 'border-gray-200'"
          :style="isActive(kiosk) ? 'border-color: var(--team-primary);' : ''"
          data-cy="kiosk-club-option"
          @click="$emit('select', kiosk)"
        >
          <img
            v-if="kiosk.team && kiosk.team.logo_url"
            :src="kiosk.team.logo_url"
            alt=""
            class="h-10 w-10 object-cover rounded-full flex-shrink-0"
          />
          <span
            v-else
            class="h-10 w-10 rounded-full flex-shrink-0 flex items-center justify-center font-bold text-white"
            :style="{ backgroundColor: (kiosk.team && kiosk.team.brand_color) || '#374151' }"
          >
            {{ initial(kiosk) }}
          </span>
          <span class="flex flex-col min-w-0 flex-1">
            <span class="text-lg font-semibold text-gray-900 truncate">{{ teamName(kiosk) }}</span>
            <span v-if="kiosk.name" class="text-sm font-medium text-gray-500 truncate">{{ kiosk.name }}</span>
          </span>
          <svg
            v-if="isActive(kiosk)"
            class="w-6 h-6 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 24 24"
            style="color: var(--team-primary);"
          >
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
          </svg>
        </button>

        <button
          class="flex items-center justify-center gap-2 w-full p-3 rounded-lg border border-dashed border-gray-300 text-gray-700 font-semibold transition hover:bg-gray-50"
          @click="$emit('add')"
        >
          <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
          </svg>
          Add another account
        </button>
      </div>

      <!-- Actions -->
      <div class="flex flex-col gap-3">
        <button
          class="w-full px-6 py-2 rounded-lg font-semibold text-base text-red-600 border border-red-200 transition-colors hover:bg-red-50"
          @click="$emit('sign-out')"
        >
          Sign out of {{ activeTeamName }}
        </button>
        <button
          class="w-full px-6 py-2 rounded-lg font-semibold text-base border transition-colors hover:bg-gray-50"
          style="border-color: var(--team-primary); color: var(--team-primary);"
          @click="$emit('cancel')"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KioskClubSwitcher',
  props: {
    kiosks: {
      type: Array,
      required: true,
    },
    activeKioskId: {
      type: Number,
      default: null,
    },
    // No admin PIN configured on the active kiosk - only offer sign-out
    limited: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select', 'add', 'sign-out', 'cancel'],
  computed: {
    activeTeamName() {
      const active = this.kiosks.find((kiosk) => this.isActive(kiosk));
      return active ? this.teamName(active) : 'this account';
    },
  },
  methods: {
    isActive(kiosk) {
      return kiosk.id === this.activeKioskId;
    },
    teamName(kiosk) {
      return (kiosk.team && kiosk.team.name) || 'Account';
    },
    initial(kiosk) {
      return this.teamName(kiosk).charAt(0).toUpperCase();
    },
  },
};
</script>
